module.exports = __webpack_public_path__ + "static/location-2b7a8d6d1de97719e49c14d764c4d42a.png";